'use client'

import { ImageWrapper } from '@/components/image'

interface RowImageProps {
  image: string | null
  href: string
  eager: boolean
}

// The product photo on the neutral inset frame (multiply blend keeps the
// cutout's white background invisible). Duplicates the name link for pointer
// users only — hidden from the tab order and assistive tech.
export const RowImage = ({ image, href, eager }: RowImageProps) => (
  <a
    href={href}
    tabIndex={-1}
    aria-hidden
    data-tracking="ignore"
    className="bg-navy/5 col-start-1 row-[1/3] flex aspect-square self-start md:row-[1/4] w-full items-center justify-center overflow-hidden rounded-xl p-1.5 md:p-3"
  >
    {image ? (
      <ImageWrapper
        image={image}
        origin="directory/row"
        loadTime={eager ? 'eager' : 'lazy'}
        sizingProps={{ sizes: '112px', minWidth: 112, maxWidth: 336, resolutionCount: 3 }}
        imgProps={{ alt: '', className: 'h-full w-full object-contain mix-blend-multiply' }}
      />
    ) : null}
  </a>
)
